// /admin/skills — real route. Mirrors apps/web's app/admin/skills/page.tsx:
// fully self-contained 'use client' page (CRUD against /api/admin/skills, no
// route params), lazy-imported directly per the porting convention
// (route-helpers.tsx). Registered from routes/admin.tsx under the `_admin`
// guard (routes/guards.tsx), parity with app/admin/layout.tsx:6.
import { lazy } from 'react';
import { createRoute } from '@tanstack/react-router';
import { adminRoute } from './guards';

const AdminSkillsPage = lazy(() => import('@/app/admin/skills/page'));

export const adminSkillsRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: '/admin/skills',
  component: AdminSkillsPage,
});
